import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AccountService } from '@shared/services/account.service';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-withdrawal-3a',
  templateUrl: './withdrawal-3a.component.html',
  styleUrls: ['./withdrawal-3a.component.scss'],
  standalone: false
})
export class Withdrawal3AComponent {
  @Input() currentAccount;
  withdrawForm: FormGroup;
  success = false;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private trackingService: TrackingService
  ) {
    this.withdrawForm = this.formBuilder.group({
      withdrawalType: ['', Validators.required],
      message: ['']
    });
  }

  submitForm(): void {
    if (this.withdrawForm.invalid) return;

    this.loading = true;

    const { withdrawalType, message } = this.withdrawForm.value;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const supportMessage = `Selected withdrawal type: ${withdrawalType} | ${message}`;

    this.accountService.createSupportTicket(supportMessage).subscribe(
      (response) => {
        if (response['success']) {
          this.trackingService.trackActivity('Request withdrawal', true);
          this.success = true;
          this.withdrawForm.reset();
        } else {
          this.loading = false;
        }
      },
      () => {
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}
